import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Events from "@/pages/Events";

export const Route = createFileRoute("/en/events/")({
  head: () => buildRouteHead("/en/events"),
  component: Events,
});

